import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Dashboard: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100dvh - 80px)',
    padding: '24px',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
}));

export { useStyles };
